/**
 * Google Analytics utility functions
 * Handles all GA event tracking throughout the application using gtag.js
 */

// Declare gtag function type for TypeScript
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    dataLayer?: any[];
  }
}

/**
 * Track a page view in Google Analytics
 */
export const trackPageView = (path: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', 'G-5LVSEJYVQY', {
      page_path: path,
    });
  }
};

/**
 * Track a custom event in Google Analytics
 */
export const trackEvent = (
  action: string,
  category: string = 'general',
  label?: string,
  value?: number
) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

/**
 * Track form submission events
 */
export const trackFormSubmission = (formName: string, formData?: Record<string, any>) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'form_submit', {
      event_category: 'Contact Form',
      event_label: formName,
      form_data: formData,
    });
  }
};

/**
 * Track conversion events
 */
export const trackConversion = (conversionType: string, value?: number) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'conversion', {
      event_category: 'Conversion',
      event_label: conversionType,
      value: value,
    });
  }
};

